"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_lazyload_1 = require("react-lazyload");
var Helpers = require("helpers");
var Image = /** @class */ (function (_super) {
    __extends(Image, _super);
    function Image(props) {
        var _this = _super.call(this, props) || this;
        _this.container = null;
        _this.state = {
            backgroundImage: null,
            mounted: false,
            imageWidth: props.width ? props.width : 1
        };
        return _this;
    }
    Image.prototype.render = function () {
        return React.createElement(React.Fragment, null, this.buildImage(this.props));
    };
    Image.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({
            mounted: true
        });
        window.addEventListener("resize", function () {
            if (_this.container && !_this.props.width) {
                _this.setState({
                    imageWidth: _this.container.clientWidth
                });
            }
        });
    };
    Image.prototype.componentDidUpdate = function () {
        if (this.container && this.state.imageWidth !== this.container.clientWidth && !this.props.width) {
            this.setState({
                imageWidth: this.container.clientWidth
            });
        }
    };
    Image.prototype.handleLoad = function (src) {
        this.setState({
            backgroundImage: encodeURI(src)
        });
    };
    Image.prototype.buildImage = function (props) {
        var _this = this;
        var bg = props.bg, contain = props.contain, height = props.height, ratio = props.ratio, src = props.src, title = props.title, width = props.width, className = props.className, bgNatural = props.bgNatural, innerClass = props.innerClass, lazyLoad = props.lazyLoad;
        var _a = this.state, imageWidth = _a.imageWidth, mounted = _a.mounted;
        return !bgNatural ? (React.createElement("div", { className: "" + (className ? className + " " : "") + (ratio && ratio != "null" && ratio != "natural" ? "ratio-" + ratio + " " : "") + (!this.state.backgroundImage ? (bg ? "bg-" + bg : "bg-" + (contain ? "transparent" : "fleece")) : "bg-transparent") + " transition-fast", style: props.style ? props.style : null, ref: function (container) {
                _this.container = container;
            } },
            src && src.length && (React.createElement("img", { className: (this.props.imageAttributes ? this.props.imageAttributes : "") + " w-full h-full absolute pin " + (this.state.backgroundImage ? "opacity-100" : "opacity-0") + " " + (contain ? "bg-contain" : "bg-cover") + " transition-fast bg-center bg-no-repeat " + (innerClass || ""), style: { objectFit: "cover" }, 
                // style={{
                //   backgroundImage: `url(${
                //     src.toLowerCase().includes("cdn.shopify.com") ? Helpers.getSizedImageUrl(src, `${imageWidth}x`) : encodeURI(src)
                //   })`
                // }}
                src: src.toLowerCase().includes("cdn.shopify.com") ? Helpers.getSizedImageUrl(src, imageWidth + "x") : src })),
            height && width && ratio == "natural" && !this.state.backgroundImage && (React.createElement("div", { className: "w-full", style: { paddingTop: Number((height / width) * 100) + "%" } })),
            src && src.length && this.state.mounted && imageWidth !== 0 ? (!lazyLoad ? (React.createElement("img", { src: src.toLowerCase().includes("cdn.shopify.com") ? Helpers.getSizedImageUrl(src, imageWidth + "x") : src, className: (ratio == "natural" ? "block invisible opacity-0 pointer-events-none" : "visually-hidden") + " " + innerClass, alt: title, "aria-label": title, onLoad: function () { return _this.handleLoad(src); } })) : (React.createElement(react_lazyload_1.default, { debounce: false, offset: 200 },
                React.createElement("img", { src: src.toLowerCase().includes("cdn.shopify.com") ? Helpers.getSizedImageUrl(src, imageWidth + "x") : src, className: (ratio == "natural" ? "block invisible opacity-0 pointer-events-none" : "visually-hidden") + " " + innerClass, alt: title, "aria-label": title, onLoad: function () { return _this.handleLoad(src); } })))) : null,
            props.children)) : (src && src.length && (React.createElement("img", { src: src.toLowerCase().includes("cdn.shopify.com") ? Helpers.getSizedImageUrl(src, imageWidth + "x") : src, alt: title, "aria-label": title, className: width + " " + className, onLoad: function () { return _this.handleLoad(src); } })));
    };
    return Image;
}(React.Component));
exports.Image = Image;
